const white = '#FFFFFF'
const black = '#000000'

const grey50 = '#FAFAFA'
const grey100 = '#F2F2F2'
const grey200 = '#E3E3E3'
// const grey300 = '#D3D3D3'
const grey400 = '#BDBDBD'
// const grey500 = '#88888B'
const grey600 = '#6F6F72'
const grey700 = '#565659'
const grey800 = '#3E3E40'
const grey900 = '#252528'

// const blue50 = '#DFF2FF'
const blue100 = '#B2D6FF'
// const blue200 = '#84BBFA'
// const blue300 = '#55A0F5'
const blue400 = '#2885F1'
// const blue500 = '#0E6BD7'
const blue800 = '#00244C'

const green100 = '#BAF3E0'
const green500 = '#28BD8C'
const green800 = '#00402E'

const red100 = '#FFB5BD'
const red400 = '#F1273C'
const red800 = '#4B0008'

const orange100 = '#FFCDB0'
const orange400 = '#FD6E1D'
const orange800 = '#4E1B00'

export const yellow400 = '#FECC1F'

// Aliases
export const primary = blue400
export const onPrimary = white
export const primaryContainer = blue100
export const onPrimaryContainer = blue800

export const success = green500
export const onSuccess = white
export const successContainer = green100
export const onSuccessContainer = green800

export const error = red400
export const onError = white
export const errorContainer = red100
export const onErrorContainer = red800

export const warning = orange400
export const warningContainer = orange100
export const onWarningContainer = orange800

export const outline = grey200
export const fill = grey800

export const surface = grey50
export const onSurface = grey900
export const onSurfaceVariant = grey700
export const surfaceDisabled = grey100
export const surfaceDim = grey100
export const onSurfaceDisabled = grey400
export const surfaceBright = white
export const surfaceBrightHover = grey100
export const surfaceBrightPressed = grey200
export const onSurfacePlaceholder = grey600
export const dialogBackground = grey50
export const hairline = grey100
export const rowHoverBackground = grey50

// Dark Theme Aliases
export const surfaceDark = black
export const onSurfaceDark = white
export const onSurfaceVariantDark = grey400 // For labelText: '#BBB'
export const outlineDark = grey800 // For border: '#444'
export const surfaceDimDark = black // For offset: '#080808' (using black for now)
export const surfaceBrightHoverDark = grey900
export const surfaceDisabledDark = grey900 // For banner: '#181818'
export const highlightDark = orange100 // For highlight: '#FFCB8D'
export const onSurfaceMutedDark = grey700 // For mutedText: '#555'
export const onSurfaceDarkContrast = black // For invertedText: '#000'
export const onSurfaceDisabledDark = grey600 // For disabledText: '#666'
export const linkTextDark = orange100 // For linkText: '#FFCB8D'
export const dialogBackgroundDark = grey900
export const hairlineDark = grey900
export const rowHoverBackgroundDark = 'rgba(255, 255, 255, 0.06)'

// Component-specific themeing
export const mainMenuBackgroundLight = surfaceBright
export const mainMenuBackgroundDark = grey800

// Syntax highlighting, shared by JsonView and DynamicForm's read-only field
// text so both surfaces color the same data type the same way. `container`,
// `currency`, and `muted` are Form View-only: JsonView never infers meaning
// from key names (no `currency`), and colors its own brackets/commas via
// `punctuation` rather than tinting a whole container one color.
const syntaxOrange = '#D28140' // string
const syntaxSlateBlue = '#7E96C4' // number
const syntaxPurple = '#573B79' // boolean
const syntaxPurpleDark = '#6F5391' // boolean, dark — frozen from color.preventTooDark()
const syntaxPink = '#F8B8B7' // null
const syntaxGreen = '#3D9970' // currency
const syntaxGrey = '#444444' // container (array/object)
const syntaxGreyDark = '#6D6D6D' // container, dark — frozen from color.preventTooDark()
const syntaxMuted = '#AAAAAA' // muted (empty string/array/object)

export const syntax = {
  key: grey900,
  string: syntaxOrange,
  number: syntaxSlateBlue,
  boolean: syntaxPurple,
  null: syntaxPink,
  // 4.2:1 on black, below AA, accepted deliberately: the next lighter grey is
  // 11.2:1 and makes braces read louder than the values between them.
  punctuation: grey600,
  container: syntaxGrey,
  currency: syntaxGreen,
  muted: syntaxMuted,
}

export const syntaxDark: typeof syntax = {
  ...syntax,
  key: grey100,
  boolean: syntaxPurpleDark,
  container: syntaxGreyDark,
}
